import { createFileRoute } from "@tanstack/react-router";
import PartnerPortal from "@/pages/PartnerPortal";

export const Route = createFileRoute("/colaboradores")({
  head: () => ({
    meta: [
      { title: "Portal de colaboradores | Retail Lemon" },
      { name: "description", content: "Acceso privado para profesionales homologados por Retail Lemon." },
      { property: "og:title", content: "Portal de colaboradores | Retail Lemon" },
      { property: "og:description", content: "Acceso privado para profesionales homologados por Retail Lemon." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: PartnerPortal,
});
